import { get, find, contains } from 'lodash';

import { VALIDATOR_PRIORITY_LOW } from './ConstraintValidatorPriorities';

export default {
  validationPriority: VALIDATOR_PRIORITY_LOW,
  validate: (question, visible, answers, payload, config, ln) => {
    const payloadQuestion = Array.isArray(payload.question) ? payload.question : [payload.question];
    const payloadPart = Array.isArray(payload.part) ? payload.part : [payload.part];

    const targetAnswered = find(payloadQuestion, questionId => {
      return contains(payloadPart, get(answers[questionId], 'part.id'));
    });

    // If one or more of the targeted questions are answered, we validate that this question is answered.
    // Otherwise we return true because if the targeted questions aren't answered, this question is not required
    const valid = targetAnswered ? get(answers, [question.id]) !== undefined : true;

    return {
      valid: valid,
      messaging: valid ? null : { message: (config.features.pleaseCompleteText[ln] || config.features.pleaseCompleteText['en_US']) 
        + (question.control == 'TextInput' ? (config.features.requiredFieldText[ln] || config.features.requiredFieldText['en_US']) 
        : (config.features.requiredChoiceText[ln] || config.features.requiredChoiceText['en_US'])) }
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/RequiredIfQuestionSelectionIs.js